import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ContactCTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="relative py-24 overflow-hidden" style={{ backgroundColor: '#151e51' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"></div>
        <div className="absolute h-96 w-96 -top-48 -right-48 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute h-96 w-96 -bottom-48 -left-48 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8 md:space-y-12">
          {/* Title */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white">
            {t('contactCTA.title')}
          </h2>
          
          {/* Description */}
          <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-300">
            {t('contactCTA.description')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/iletisim')}
              className="group relative overflow-hidden bg-white text-[#151e51] rounded-full font-medium inline-flex items-center px-8 py-3 text-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
            >
              <span className="z-10">{t('contactCTA.primaryButton')}</span>
              <div className="absolute inset-0 bg-gray-100 translate-y-12 group-hover:translate-y-0 transition-transform duration-300"></div>
            </button>
            
            <a
              href="mailto:info@orbitras.com"
              className="group text-white hover:text-white/90 font-medium inline-flex items-center text-lg transition-colors duration-300 border border-white/20 px-6 py-2 rounded-full hover:bg-white/10"
            >
              {t('contactCTA.secondaryButton')}
              <svg
                className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA; 